<template>
  <app-layout title="Organisations">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <br />
      <!-- progress bar start from here -->
       
      <div class="container mt-10">
        <ol class="steps">
          <li class="step is-active" data-step="1">Organisation</li>
          <li class="step " data-step="2">Host</li>
          <li class="step" data-step="3">Billing Info</li>
          <li class="step" data-step="4">Place Order</li>
          <li class="step" data-step="5">Checkout</li>
          <li class="step" data-step="6">Deploy</li>
        </ol>
      </div>
      <br/>
      <!-- progress end  -->
      <!-- <div class="row">
        <div class="col-lg-12 col-12 text-center">
          <h5 class="">Your Host</h5>
          <h6 class="text-center">
            (Select a host to deploy the product)
          </h6>
          <br />

          <div class="grid grid-cols-10 gap-2 mt-2">
            <div class="bg-white rounded-md hover:cursor-pointer card-style">
              <jet-responsive-nav-link @click="showCreatePopup()">
                <i
                  class="fas fa-plus fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />
                <div class="text-center leading-4 pb-2">Create a Host</div>
              </jet-responsive-nav-link>
            </div>

            <div
              class="bg-white rounded-md hover:cursor-pointer card-style"
              v-for="(d, b) in this.prodNotDeployedTenant"
              :key="b"
            >
              <jet-responsive-nav-link @click="goToBillingAccount(d.id)">
                <i
                  class="fas fa-cubes fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />
                <div class="text-center leading-4 pb-2">{{ d.name }}</div>
              </jet-responsive-nav-link>
            </div>

            <div
              class="bg-white rounded-md hover:cursor-pointer card-style"
              v-for="(d, b) in this.prodDeployedTenant"
              :key="b"
            >
              <jet-responsive-nav-link @click="showAlert()">
                <i
                  class="fas fa-cubes fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />
                <div class="text-center leading-4 pb-2">{{ d.name }}</div>
              </jet-responsive-nav-link>
            </div>
          </div>
        </div>
      </div> -->
      <section>
      <div class="container">
         <div class="grid grid-cols-3 gap-4 ">
              <!-- left side end -->
              <div class=" col-span-2 border-2 border-grey-600 bg-white mb-4">
                    <!-- left billing -->
                    
                    <h4 class="font-semibold text-left mx-4 pt-4 leading-none">Your Organisations</h4>
                     <h6 class="text-left mx-4 text-sm mb-3">Select an organisation to deploy the product or
                       <jet-responsive-nav-link @click="showCreatePopup()">create new</jet-responsive-nav-link></h6>
               
                      



                <div class=" mx-4 mb-3">
                   <!-- cards 1 start -->
          <label  v-for="(value,key) in Cards" class=" card">
    <input name="plan" class="radio" type="radio" >
     
         <span class="text-left plan-details">
                  <h6 class="cursor-pointer">{{value.name}}</h6>
          </span>
         </label>
                    
                 <!-- cards end -->
                </div>

               
                <!-- left billing end -->
              </div>
               <!-- left side end -->
              <!-- ... -->
              <!-- right side start -->
              <div class=" border-2 border-grey-600 bg-white mb-4">
               <div class="mx-4 my-4">
                <div class="flex justify-between ">
                 <div class="font-semibold text-lg">Product Details</div>
                     <i class="dx-icon-edit"></i>
                  </div>
                      <p class="text-gray-500"> Product Name</p>
                      <p class="text-gray-500">Subsciption Plan</p>
                      <p class="text-gray-500">Subscription Price</p>

              <div class="flex justify-between mt-4">
                <button href="#" type="button" class="rounded-md font-bold  text-gray-700 px-4 py-2" style="background-color:#cdcdcd">
                  <i class="dx-icon-chevrondoubleleft"></i>
                  <!-- &laquo; &nbsp; -->
                   Back</button>
                <button href="#" type="button" class="rounded-md font-bold bg-green-500 text-white px-4 py-2" id="">Next
                      <i class="dx-icon-chevrondoubleright"></i>
                   <!-- &nbsp;  &raquo; -->
                   </button>

                <!-- <button>
                <a type="button" id="previous1"> &laquo; Back </a>
                  </button>
                 <button>
                  <a type="button" id="next1">Next
                    </a></button> -->
              </div>
              </div>
              </div>
             <!-- Right end -->
            </div>

      <!-- pop up for quick create -->
      <DxPopup
        v-model:visible="createPopupVisible"
        :drag-enabled="true"
        :show-close-button="true"
        :close-on-outside-click="false"
        :show-title="true"
        :resizeEnabled="true"
        :title="creatTitle"
      >
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="saveButtonOptions"
        />
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="closeButtonOptions"
        />

        <DxScrollView width="100%" height="100%">
          <BsOnBoardForm
            :routeDef="this.routeDef"
            :createDef="this.tenantListDef"
            :modelData="modelData"
            ref="onboardHostformRenderer"
          />
        </DxScrollView>
      </DxPopup>

      <!-- pop to if product  is already is deployed -->
      <!-- pop up for quick create -->
      <DxPopup
        v-model:visible="productPopupVisible"
        :drag-enabled="true"
        :show-close-button="true"
        :close-on-outside-click="true"
        :show-title="true"
        :resizeEnabled="true"
        :title="creatTitle"
      >
        <div>
          <h6>This product is already deployed with This organisation.</h6>
        </div>
      </DxPopup>
      </div>
      </section>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";
import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";

export default {
  props: {
    productId: String,
    subscriptionPriceId: String,
    subscriptionPlanId: String,
    accountId: String,
     accounts: {
      type: Array,
      default: () => [],
    },
    tenantListDef: {
      type: Array,
      default: [],
    },
    //userTanantsList Array with default value
    prodDeployedTenant: {
      type: Array,
      default: () => [],
    },

    prodNotDeployedTenant: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxPaging,
    BsOnBoardForm,
    DxScrollView,
  },
  data() {
    return {
      tenantData: null,
      productData: null,
      title: "Organisations",
      routeDef: "tenant-lists",
      createPopupVisible: false,
      productPopupVisible: false,
       Cards:[{"name":"Product Name"},{"name":"Subscription Plan "},{"name":"Subscribe Price"},],
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.saveRecord,
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.createPopupVisible = false;
        },
      },
    };
  },
  methods: {
    goToBillingAccount(tenantId) {
      var data = {
        productId: this.productId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptionPriceId: this.subscriptionPriceId,
        accountId: this.accountId,
        tenantId: tenantId,
      };
      console.log("Organisation", data);
      this.$inertia.post(route("marketplaces.billingaccounts"), data);
    },

    showCreatePopup() {
      this.createPopupVisible = true;
    },

    showAlert() {
      this.productPopupVisible = true;
    },
    saveRecord() {
      this.$refs.onboardHostformRenderer.formData.accountId = this.accountId;

      this.$inertia.post(
        // route(
        //   "onboard.organisations",
        //   this.$refs.onboardHostformRenderer.formData
           route( "marketplaces.onboard.accounts", this.$refs.onboardAccountformRenderer.formData)  
      );
      this.createPopupVisible = false;
    },
  },
  mounted() {
     console.log("Accounts",this.subscriptionPriceId);
    // $(window).bind('beforeunload',function(){
    //   console.log("beforeunload");
    //   return null;
    // });
    // this.getOrganisation();
    // this.getProductId();
  },
};
</script>

<style>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

.img-company {
  width: 50px;
  height: 50px;
}

.no-decoration {
  text-decoration: none;
}

.no-decoration:hover {
  text-decoration: none;
}

.organisations-container {
  width: 50% !important;
  background: var(--white);
}

.ul-add-organisation {
  background-color: var(--blue);
}

.btn-submit {
  background-color: var(--blue);
}

/* progress css start here  */
.steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: table;
  table-layout: fixed;
  width: 100%;
  color: #929292;
  margin-top: 10px;
  height: 1rem;
}
.steps > .step {
  position: relative;
  display: table-cell;
  text-align: center;
  font-size: 0.875rem;
  color: #6d6875;
}
.steps > .step:before {
  content: attr(data-step);
  display: block;
  margin: 0 auto;
  background: #ffffff;
  border: 2px solid #e6e6e6;
  color: #e6e6e6;
  width: 2rem;
  height: 2rem;
  text-align: center;
  margin-bottom: -4.2rem;
  line-height: 1.9rem;
  border-radius: 100%;
  position: relative;
  z-index: 1;
  font-weight: 700;
  font-size: 1rem;
}
.steps > .step:after {
  content: "";
  position: absolute;
  display: block;
  background: #e6e6e6;
  width: 100%;
  height: 0.125rem;
  top: 1rem;
  left: 50%;
}
.steps > .step:last-child:after {
  display: none;
}
.steps > .step.is-complete {
  color: #6d6875;
}
.steps > .step.is-complete:before {
  content: "✓";
  color: #fff;
  background: #10b981;
  border: 2px solid #10b981;
}
.steps > .step.is-complete:after {
  background: #10b981;
}
.steps > .step.is-active {
  font-size: 1.25rem;
  margin-top: 10px;
}
.steps > .step.is-active:before {
  color: #fff;
  border: 2px solid #10b981;
  background: #10b981;
  margin-bottom: -4.9rem;
}

/**
 * Some Generic Styling
 */
*,
*:after,
*:before {
  box-sizing: border-box;
}

h1 {
  margin-bottom: 1.5em;
}

.steps {
  margin-bottom: 1em;
}
/* progress end here */
/* after steps */
.card {
  background-color: #fff;
  border-radius: var(--card-radius);
  position: relative;
}
.card:hover {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
}

.radio {
  font-size: inherit;
  margin: 0;
  position: absolute;
  right: calc(var(--card-padding) + var(--radio-border-width));
  top: calc(var(--card-padding) + var(--radio-border-width));
}

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  .radio {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: #fff;
    border: var(--radio-border-width) solid var(--color-gray);
    border-radius: 50%;
    cursor: pointer;
    height: var(--radio-size);
    outline: none;
    transition: background 0.2s ease-out, border-color 0.2s ease-out;
    width: var(--radio-size);
  }
  .radio::after {
    border: var(--radio-border-width) solid #fff;
    border-top: 0;
    border-left: 0;
    content: "";
    display: block;
    height: 0.75rem;
    left: 25%;
    position: absolute;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -50%);
    width: 0.375rem;
  }
  .radio:checked {
    background: var(--color-blue);
    border-color: var(--color-blue);
  }

  .card:hover .radio {
    border-color: var(--color-dark-gray);
  }
  .card:hover .radio:checked {
    border-color: var(--color-blue);
  }
}
.plan-details {
  border: var(--radio-border-width) solid var(--color-gray);
  border-radius: var(--card-radius);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: var(--card-padding);
  transition: border-color 0.2s ease-out;
}

.card:hover .plan-details {
  border-color: var(--color-dark-gray);
}

.radio:checked ~ .plan-details {
  border-color: var(--color-blue);
}

.radio:focus ~ .plan-details {
  box-shadow: 0 0 0 2px var(--color-dark-gray);
}

.radio:disabled ~ .plan-details {
  color: var(--color-dark-gray);
  cursor: default;
}

.radio:disabled ~ .plan-details .plan-type {
  color: var(--color-dark-gray);
}

.card:hover .radio:disabled ~ .plan-details {
  border-color: var(--color-gray);
  box-shadow: none;
}

.card:hover .radio:disabled {
  border-color: var(--color-gray);
}

.plan-type {
  color: var(--color-blue);
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1em;
}

.plan-cost {
  font-size: 1rem;
  font-weight: bold;
  padding: 0.5rem 0;
}

.slash {
  font-weight: normal;
}

.plan-cycle {
  font-size: 1rem;
  font-variant: none;
  border-bottom: none;
  cursor: inherit;
  text-decoration: none;
}

.hidden-visually {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
:root {
  --card-line-height: 1.2em;
  --card-padding: 1em;
  --card-radius: 0.5em;
  --color-green: #0ecb8f;
  --color-gray: #e2ebf6;
  --color-dark-gray: #c4d1e1;
  --radio-border-width: 2px;
  --radio-size: 1.5em;
  --color-blue: #2563eb;
}
h4{
    margin-bottom: 0rem;
/* font-weight: 500; */
line-height: 1.2;
}
p{
  margin-bottom: -3px;
}
/* button start */
.dx-icon-edit {
  font: 20px/1 DXIcons;
}

</style>

